import { ReactComponent as Account } from '../../assets/icons/account.svg';
import { ReactComponent as BigCheckBox } from '../../assets/icons/BigChecked-box.svg';
import { ReactComponent as BigCross } from '../../assets/icons/BigCross.svg';
import { ReactComponent as BigFork } from '../../assets/icons/BigFork.svg';
import { ReactComponent as BigInfo } from '../../assets/icons/BigInfo.svg';
import { ReactComponent as Book } from '../../assets/icons/Book-open.svg';
import { ReactComponent as Business } from '../../assets/icons/Business.svg';
import { ReactComponent as BusinessActive } from '../../assets/icons/BusinessActive.svg';
import { ReactComponent as Calendar } from '../../assets/icons/Calendar.svg';
import { ReactComponent as CalendarInactive } from '../../assets/icons/CalendarInactive.svg';
import { ReactComponent as Camera } from '../../assets/icons/Camera.svg';
import { ReactComponent as CaretLeft } from '../../assets/icons/Caret left.svg';
import { ReactComponent as Caret } from '../../assets/icons/Caret_right.svg';
import { ReactComponent as Check } from '../../assets/icons/Check.svg';
import { ReactComponent as Coin } from '../../assets/icons/dollar_coin.svg';
import { ReactComponent as DollarCoinActive } from '../../assets/icons/dollar_coin_active.svg';
import { ReactComponent as Envelope } from '../../assets/icons/Envelope.svg';
import { ReactComponent as EyeClosed } from '../../assets/icons/Eye-closed.svg';
import { ReactComponent as Eye } from '../../assets/icons/Eye.svg';
import { ReactComponent as Fork } from '../../assets/icons/Fork.svg';
import { ReactComponent as ForkInactive } from '../../assets/icons/ForkInactive.svg';
import { ReactComponent as Home } from '../../assets/icons/Home.svg';
import { ReactComponent as HomeInactive } from '../../assets/icons/HomeInactive.svg';
import { ReactComponent as IceCream } from '../../assets/icons/IceCream.svg';
import { ReactComponent as IceCreamActive } from '../../assets/icons/IceCreamActive.svg';
import { ReactComponent as Images } from '../../assets/icons/images.svg';
import { ReactComponent as ImagesActive } from '../../assets/icons/imagesActive.svg';
import { ReactComponent as Key } from '../../assets/icons/Key.svg';
import { ReactComponent as Arrow } from '../../assets/icons/left_arrow.svg';
import { ReactComponent as Location } from '../../assets/icons/Location.svg';
import { ReactComponent as Pencil } from '../../assets/icons/Pencil.svg';
import { ReactComponent as Phone } from '../../assets/icons/Phone.svg';
import { ReactComponent as Plus } from '../../assets/icons/Plus.svg';
import { ReactComponent as Salad } from '../../assets/icons/Salads.svg';
import { ReactComponent as SaladActive } from '../../assets/icons/SaladsActive.svg';
import { ReactComponent as SidebarMenu } from '../../assets/icons/sidebarMenu.svg';
import { ReactComponent as Success } from '../../assets/icons/Success.svg';
import { ReactComponent as Trash } from '../../assets/icons/Trash.svg';
import { ReactComponent as Union } from '../../assets/icons/Union.svg';
import { ReactComponent as User } from '../../assets/icons/User.svg';
import { ReactComponent as Users } from '../../assets/icons/users.svg';
import { ReactComponent as Warning } from '../../assets/icons/Warning.svg';
import { ReactComponent as Watch } from '../../assets/icons/watch.svg';
import { ReactComponent as Wheel } from '../../assets/icons/wheel.svg';
import { ReactComponent as WheelActive } from '../../assets/icons/wheelActive.svg';

const iconList = {
  trash: Trash,
  eye: Eye,
  eyeClosed: EyeClosed,
  key: Key,
  mail: Envelope,
  union: Union,
  caret: Caret,
  watch: Watch,
  calendar: Calendar,
  calendarInactive: CalendarInactive,
  user: User,
  users: Users,
  book: Book,
  account: Account,
  arrow: Arrow,
  bigFork: BigFork,
  fork: Fork,
  forkInactive: ForkInactive,
  location: Location,
  phone: Phone,
  coin: Coin,
  warning: Warning,
  camera: Camera,
  plus: Plus,
  check: Check,
  home: Home,
  homeInactive: HomeInactive,
  business: Business,
  businessActive: BusinessActive,
  iceCream: IceCream,
  iceCreamActive: IceCreamActive,
  salad: Salad,
  saladActive: SaladActive,
  sidebarMenu: SidebarMenu,
  bigCheckBox: BigCheckBox,
  bigInfo: BigInfo,
  bigCross: BigCross,
  wheel: Wheel,
  wheelActive: WheelActive,
  success: Success,
  images: Images,
  imagesActive: ImagesActive,
  caretLeft: CaretLeft,
  dollarCoinActive: DollarCoinActive,
  pencil: Pencil,
};

export default iconList;
